import { Icon } from './Icon'
import { useMedia } from '../hooks/useMedia'

type Depoimento = {
  sigla: string
  empresa: string
  texto: string
  pessoa: string
  cargo: string
}

/* Depoimentos de exemplo. Ao trocar por reais, so substituir o conteudo. */
const DEPOIMENTOS: Depoimento[] = [
  { sigla: 'BD', empresa: 'Burguer DaVilla', texto: 'A Skyenex transformou a forma como enxergamos o delivery. Nossa loja ficou mais organizada e hoje temos muito mais pedidos pelo iFood.', pessoa: 'Lucas Almeida', cargo: 'Proprietário' },
  { sigla: 'NP', empresa: 'Nonna Pizzaria', texto: 'A equipe da Skyenex nos ajudou a estruturar toda a nossa operação no 99 Food. O processo foi muito profissional e hoje temos uma loja mais competitiva.', pessoa: 'Maria Fernanda', cargo: 'Proprietária' },
  { sigla: 'SH', empresa: 'Sabor da Hora', texto: 'Além de estruturarem nosso perfil no iFood e na 99 Food, a Skyenex nos orientou na precificação e nas promoções. Hoje temos mais controle e vemos a diferença no dia a dia.', pessoa: 'Rafael Souza', cargo: 'Proprietário' },
  { sigla: 'CM', empresa: 'Cantina da Marina', texto: 'O cardápio estava bagunçado e a gente nem percebia. Depois da reorganização, o ticket médio subiu e as dúvidas no atendimento caíram bastante.', pessoa: 'Marina Torres', cargo: 'Proprietária' },
  { sigla: 'EB', empresa: 'Esquina do Bolo', texto: 'O que mais me ajudou foi o acompanhamento. Todo mês recebo os números e sei exatamente o que ajustar na loja.', pessoa: 'Diego Martins', cargo: 'Sócio' },
  { sigla: 'TG', empresa: 'Tempero da Gu', texto: 'Comecei do zero no delivery e não fazia ideia por onde começar. Eles cuidaram do cadastro, das fotos e das taxas. Em poucas semanas a loja estava rodando.', pessoa: 'Gustavo Lima', cargo: 'Proprietário' },
]

function Quote({ d, clone }: { d: Depoimento; clone?: boolean }) {
  return (
    <li className="quote" aria-hidden={clone || undefined}>
      <div className="quote__top">
        <span className="quote__avatar">{d.sigla}</span>
        <span className="quote__meta">
          <b>{d.empresa}</b>
          <span className="stars" aria-label="5 de 5 estrelas">
            {Array.from({ length: 5 }, (_, i) => <Icon name="star" key={i} />)}
          </span>
        </span>
      </div>
      <p>{`“${d.texto}”`}</p>
      <footer><b>{d.pessoa}</b><small>{d.cargo}</small></footer>
    </li>
  )
}

export function Social() {
  const { reduced } = useMedia()

  // A animacao desloca a faixa em -50%, entao ela precisa conter duas copias
  // identicas — e a segunda sai da arvore de acessibilidade, senao o leitor de
  // tela anuncia cada depoimento duas vezes.
  const estiloParado = reduced
    ? { animation: 'none', flexWrap: 'wrap' as const, width: '100%' }
    : undefined

  return (
    <section className="social">
      <div className="shell social__inner">
        <div className="social__head">
          <p className="eyebrow eyebrow--dark" data-reveal="up"><i />Clientes e resultados</p>
          <h2 className="h2" data-reveal="mask">Quem cresce com a <span className="accent">Skyenex.</span></h2>
          <p className="social__lead" data-reveal="up" data-delay="110">
            Experiências reais de quem confiou na nossa estratégia, estruturação e acompanhamento.
          </p>
          <span className="script script--3" data-reveal="up" data-delay="200">
            Mais que clientes,<br />parceiros de crescimento.
          </span>
        </div>

        <div className="social__viewport" data-reveal="up">
          <ul className="social__track" style={estiloParado}>
            {DEPOIMENTOS.map((d) => <Quote d={d} key={d.empresa} />)}
            {!reduced && DEPOIMENTOS.map((d) => <Quote d={d} clone key={`${d.empresa}-clone`} />)}
          </ul>
        </div>
      </div>
    </section>
  )
}
